import{Z as o,d as s}from"./p-DKQ3rVD4.js";const r=o;const t=s;export{r as ZprLabel,t as defineCustomElement};
//# sourceMappingURL=zpr-label.js.map